export const CART_LINE_QUANTITY_CAP = 10
